import HttpClient from "../http/http_client";
export const postEventRequest = async (eventDetails) => {
    try {
        const response = await HttpClient.post(`event/`, eventDetails, {
            headers : {"Content-Type": "application/json"},
        });

        return {
            success : true,
            data : response.data,
        }
    } catch (error) {
        if (error.response) {
            const {status, data} = error.response;
            return {
                success : false,
                status: status,
                errors : data?.errors || null,
            };
        }

        return {
            success : false,
            status : null,
            errors : "Something went wrong. Please try again.",
        };
    }
};

export const getAllEventRequest = async () => {
    try {
        const response = await HttpClient.get(`event/`);
        return {
            success : true,
            data : response.data,
        }
    } catch (error) {
        if (error.response) {
            const {status, data} = error.response;
            return {
                success : false,
                status : status,
                errors : data?.errors || null,
            };
        }

        return {
            success : false,
            status : null,
            errors : "Something went wrong. Please try again.",
        };
    }
};


export const getEventByIdRequest = async (id) => {
    try {
        const response = await HttpClient.get(`event/${id}/`);
        return {
            success : true,
            data : response.data,
        }
    } catch (error) {
        if (error.response) {
            const {status, data} = error.response;
            return {
                success : false,
                status : status,
                errors : data?.errors || null,
            }
        }

        return {
            success : false,
            status : null,
            errors : "Something went wrong. Please try again."
        };
    }
};

export const updateEventRequest = async (id, updatedDetails) => {
    try {
        const response = await HttpClient.put(`event/${id}/`, updatedDetails);
        return {
            success : true,
            data : response.data,
        }
    } catch (error) {
        if (error.response) {
            const {status, data} = error.response;
            return {
                success : false,
                status : status,
                errors : data?.errors || null,
            }
        }

        return {
            success : false,
            status : null,
            errors : "Something went wrong. Please try again.",
        };
    }
};

export const deleteEventRequest = async (id) => {
    try {
        const response = await HttpClient.delete(`event/${id}/`);
        return {
            success : true,
            data: response.data,
        }
    } catch (error) {
        if (error.response) {
            const {status, data} = error.response;
            return {
                success : false,
                status : status,
                errors : data?.errors || null,
            }
        }
    };
};